var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.16667V15.8333C18.3333 16.2538 18.1745 16.6588 17.8886 16.9671C17.6027 17.2754 17.2108 17.4643 16.7915 17.4958L16.6665 17.5H3.33317C2.91269 17.5001 2.5077 17.3413 2.19938 17.0554C1.89106 16.7695 1.70221 16.3776 1.67067 15.9583L1.6665 15.8333V9.16667H18.3332ZM7.93317 2.5C8.1576 2.49999 8.37972 2.5453 8.58621 2.63322C8.7927 2.72115 8.97931 2.84987 9.13484 3.01167L9.23484 3.12583L10.3998 4.58333H16.6665C17.087 4.5832 17.492 4.74201 17.8003 5.02791C18.1086 5.31382 18.2975 5.7057 18.329 6.125L18.3332 6.25V7.5H1.6665V4.16667C1.66637 3.74619 1.82518 3.34119 2.11108 3.03288C2.39699 2.72456 2.78887 2.5357 3.20817 2.50417L3.33317 2.5H7.93317Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGray400);
export default __webpack_public_path__ + "static/media/folder_gray400.70dd83d214a184eaf61a15578c789e44.svg";
export { ForwardRef as ReactComponent };